const messages = {
  title: "Mnożnik bonusu",
  bandBonusTitle: "Bonus za oponę z mnożnikiem",
  amountLabel: "Min. liczba opon (*)",
  label: "Mnożnik bonusu",
  desc: "Liczba opon Bridgestone i Firestone. Nie ma bonusu w euro za opony Firestone.",
  goals: {
    loyal: "Lojalny",
    bronze: "Brąz",
    silver: "Srebro",
    gold: "Złoto",
    platinum: "Platyna",
  },
  andMore: "i więcej",
  chooseTarget: "Wybierz",
  selectTarget: "Wybierz swój cel roczny na {year}:",
  multiplication: "Bonus jest mnożony przez <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} opon",
};

export default {
  messages,
};
